import OrderProductItem from './OrderProductItem';

export default OrderProductItem;
